module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-winter-2800.1e7bbda5.svg";